import { FormEvent } from "react"
import { Component } from "@/types/types"
import { trackEvent } from "@/actions/_archive/global/analytics/trackEvent"
import { useCallbackOnce } from "@/hooks/utils/useCallbackOnce"
import { useOnVisible } from "@/hooks/utils/useOnVisible"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "form"

export const presets = {}

export interface Props extends Component {
  name: string
  onSubmit: () => void
}

export function Form({ name, onSubmit, children, className, testId = COMPONENT_NAME }: Props) {
  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    trackEvent("form_submitted", { form_name: name })
    onSubmit()
  }

  const handleFocusOnce = useCallbackOnce(() => {
    trackEvent("form_touched", { form_name: name })
  })

  const formRef = useOnVisible(() => {
    trackEvent("form_seen", { form_name: name })
  })

  return (
    <form
      onSubmit={handleSubmit}
      onFocus={handleFocusOnce}
      className={cx(`w-full max-w-[520px]`, `flex flex-col gap-8`, className)}
      ref={formRef}
      data-test={testId}
    >
      {children}
    </form>
  )
}
